import { Outlet } from 'react-router-dom';
import { ArticleCard, library } from '@playcastdotio/ArticleContent';

import { Helmet } from 'react-helmet-async';

const structuredData = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: 'Playcast',
  url: 'https://playcast.io',
  logo: 'https://playcast.io/images/playcast_logo-96x96.png',
  sameAs: [
    'https://discord.gg/7PYGxU68WH',
    'https://www.youtube.com/channel/UC-k16u9Ea_dvRhB70f-h5lQ',
    'https://www.twitch.tv/playcastio',
    'https://www.tiktok.com/@playcastdotio',
    'https://www.instagram.com/playcastio/',
  ],
};

// eslint-disable-next-line import/first
import { useEffect } from 'react';

export const News = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const articles = Object.keys(library.articles).map((key) => {
    const article = library.articles[key];
    return article;
  });

  return (
    <>
      <Helmet>
        <title>Playcast | Interactive Peer-to-Peer Game Streaming for Gamers</title>
        <meta
          name='description'
          content='Experience real-time, interactive peer-to-peer game streaming with Playcast. Join the community and discover seamless gameplay with low latency for gamers and streamers alike.'
        />

        <script type='application/ld+json'>{JSON.stringify(structuredData)}</script>
      </Helmet>

      <div className='bg-content text-content-text m-0 h-auto w-full p-0'>
        <div className='bg-hero bg-content text-content-text m-0 h-auto w-full bg-cover bg-no-repeat p-0'>
          <div className='container mx-auto h-auto w-full px-8 pb-8 pt-20'>
            <section id='hero' className='grid grid-cols-12 gap-x-4 gap-y-8'>
              {articles
                .sort((a, b) => {
                  return new Date(b.published).getTime() - new Date(a.published).getTime();
                })
                .map((article) => {
                  return <ArticleCard key={article.slug} article={article} />;
                })}
            </section>
          </div>
        </div>
      </div>
      <Outlet />
    </>
  );
};
